import AsyncStorage from '@react-native-async-storage/async-storage'
import { NavigationContainer, useLinkTo } from '@react-navigation/native'
import { capitalCase } from 'capital-case'
import { useEffect, useState } from 'react'
import { Linking, Platform } from 'react-native'
import clevertap from '../../../domain/services/clevertap/ClevertapAdapter'
import Configuration from '../../../domain/services/ConfigurationService'
import { navigationRef } from '../../../domain/services/RootNavigation'
import IntercomWrapper from '../components/IntercomWrapper'
import SuccessModalWrapper from '../components/SuccessModalWrapper'
import useAuthentication from '../hooks/authentication/useAuthentication'
import { guestLinks, GuestScreen } from './GuestScreen'
import { memberLinks, MemberScreen } from './MemberScreen'

// for handling clicks on notifications when the application is running (backgrounded)
const CleverTapNotificationClickHandler = ({}) => {
  const prefix = Configuration.SCHEME + '://'
  const linkTo = useLinkTo()
  clevertap.onPushNotificationClicked((deepLink) => {
    const url = deepLink?.replace(prefix, '/')
    linkTo(url)
  })
  return <></>
}

const NavigationScreen = ({}) => {
  const { user, isLoading } = useAuthentication()

  const [routeName, setRouteName] = useState(undefined)
  const [routeParams, setRouteParams] = useState(undefined)

  useEffect(() => {
    const setRedirectUrl = async () => {
      if (Platform.OS === 'web') {
        const currentUrl = window.location.href

        if (
          !user &&
          (currentUrl.includes('/activity') ||
            currentUrl.includes('/collection/'))
        ) {
          await AsyncStorage.setItem('redirectUrl', currentUrl)
        }
      }
    }
    setRedirectUrl()
  }, [user, navigationRef.current])

  const linking = {
    prefixes: [`${Configuration.SCHEME}://`],
    config: {
      screens: {
        ...memberLinks,
        ...guestLinks,
      },
    },
    getInitialURL: () => {
      return clevertap.getInitialURL().catch(() => Linking.getInitialURL())
    },
  }

  if (isLoading) return

  return (
    <NavigationContainer
      documentTitle={{
        formatter: (options, route) => {
          return `Cabana - ${capitalCase(options?.title ?? route?.name)}`
        },
      }}
      linking={linking}
      onReady={() => {
        setRouteName(navigationRef.getCurrentRoute().name)
      }}
      onStateChange={() => {
        const { name: currentRouteName, params: currentRouteParams } =
          navigationRef.getCurrentRoute()
        setRouteName(currentRouteName)
        setRouteParams(currentRouteParams)
      }}
      ref={navigationRef}>
      <CleverTapNotificationClickHandler />
      <IntercomWrapper routeName={routeName}>
        <SuccessModalWrapper routeParams={routeParams}>
          {user ? <MemberScreen /> : <GuestScreen />}
        </SuccessModalWrapper>
      </IntercomWrapper>
    </NavigationContainer>
  )
}

export default NavigationScreen
